import { useState } from "react";
import { uploadData } from "aws-amplify/storage";
import { useContextData } from "./useContextData";
import { getUrl } from "aws-amplify/storage";

type uploadParameters = {
  file: File;
  metadata: Record<string, string>;
};

const useS3 = () => {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const uploadImage = async ({ file, metadata }: uploadParameters) => {
    const fileType = file.type.split("/")[1] || "png";
    const timestamp = Date.now();
    const sanitizedName = `${timestamp}-upload.${fileType}`;

    try {
      setUploading(true);
      setProgress(0);

      const result = await uploadData({
        path: "uploads/inputs/" + sanitizedName,
        data: file,
        options: {
          metadata,
          contentType: file.type,
          onProgress: ({ transferredBytes, totalBytes }) => {
            if (totalBytes) {
              const progressPercentage = Math.round(
                (transferredBytes / totalBytes) * 100,
              );
              setProgress(progressPercentage);
            }
          },
        },
      }).result;

      return result;
    } catch (error) {
      console.log("Error : ", error);
      throw error;
    } finally {
      setUploading(false);
    }
  };

  const getUrlImage = async (key: string) => {
    try {
      const signedURL = await getUrl({
        path: key,
        options: {
          validateObjectExistence: false,
          expiresIn: 1800,
        },
      });
      return signedURL;
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  return { uploading, progress, uploadImage, getUrlImage };
};

export default useS3;
